import { Injectable } from "@angular/core";
import { OnboardingApi } from "../api/onboarding.api";

@Injectable()
export class OnboardingService {
  constructor(private onboardingApi: OnboardingApi) {}


  getTemplate = () => this.onboardingApi.getTemplate();
  onboardUsers = (fileList: FileList) =>
    this.onboardingApi.onboardUsers(fileList);
}
